import { notNull } from 'utils/type_guards';
import type {
  CartPickupMethod,
  CartShippingMethod,
  SavedCartShipping,
} from './cart_shipping.types';

function cartShippingIsShipping(shipping: SavedCartShipping): shipping is CartShippingMethod {
  return notNull(shipping) && !!shipping.street_address;
}

function cartShippingIsPickup(shipping: SavedCartShipping): shipping is CartPickupMethod {
  return notNull(shipping) && !!shipping.recipient && !shipping.street_address;
}

export default {
  cartShippingIsShipping,
  cartShippingIsPickup,
};
